<template>
  <div class="w-full h-full relative overflow-auto">
    <PasswordReset />
    <div
      class="w-full min-h-full flex flex-col items-center justify-center relative overflow-auto py-12"
    >
      <div class="flex justify-center py-6">
        <div class="w-24 h-24">
          <ImgComponent :src="platform.logo" class="w-full h-full" alt="" />
        </div>
      </div>
      <div class="w-[80%] md:max-w-[350px]">
        <div class="text-center">
          <div class="text-4xl font-bold whitespace-nowrap title-color">
            <slot name="title"></slot>
          </div>
          <!-- <div class="py-1"></div>
          <div class="font-bold whitespace-nowrap description-color">
            <slot name="subTitle"></slot>
          </div> -->
          <div class="py-3"></div>
        </div>

        <slot></slot>
        <div class="text-center pt-8">
          <span>
            <slot name="redirectQuestion"></slot>
          </span>
          &nbsp;
          <span class="text-primary-400 font-bold">
            <slot name="redirectLink"></slot>
          </span>
        </div>
        <div class="text-center pt-4">
          <span class="text-center text-primary-400 font-bold">
            <slot name="aditionnalAction"></slot>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { platform } from '@core/platform';
</script>
